import React from 'react';
import { Box, Divider, Flex, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { useBannerSize } from '../../../../common/hooks/use-banner-size';
import { formatScheduleTime } from '../../../../utils/common/time-utils';
import { COLOR_DIVIDER } from './banner-colors';

type ScheduledBannerContentProps = {
  startTime: string | null;
  endTime: string | null;
};

export function ScheduledBannerContent({ startTime, endTime }: ScheduledBannerContentProps) {
  const { t } = useTranslation();
  const { h, largeFontSize } = useBannerSize();
  return (
    <Flex align="center" w="100%" h={h}>
      <Box flex={1} textAlign="center">
        <Box fontSize={largeFontSize} _dark={{ color: 'white' }}>
          {formatScheduleTime(startTime)}
        </Box>
        <Text fontSize="12px">{t('Common.start time')}</Text>
      </Box>
      <Divider orientation="vertical" h="50px" borderColor={COLOR_DIVIDER} />
      <Box flex={1} textAlign="center">
        <Box fontSize={largeFontSize} _dark={{ color: 'white' }}>
          {formatScheduleTime(endTime)}
        </Box>
        <Text fontSize="12px">{t('Common.end time')}</Text>
      </Box>
    </Flex>
  );
}
